/**
 * Import Foundation Components
 * check ./foundation.js if you need to enable more
 */

import vue from "vue";

// simple onclick to show form results and actions

// do form calculation stuff
if ($("#calculatorApp .calculator__form").length > 0) {
    let standardRate = $("#calculatorApp .calculator__form").data(
        "standard-rate"
    );
    if (standardRate.length <= 0) {
        standardRate = 0.159;
    }

    var calculatorApp = new vue({
        el: "#calculatorApp",
        delimiters: ["${", "}"], // prevent Twig conflicts
        data: {
            fees: 523,
            frequency: "week",
            loan: "10000",
            months: "48",
            rate: standardRate,
            maxLoan: 1000000
        },
        computed: {
            repayments: function(e) {
                if (this.loan <= this.fees) {
                    return this.currencyFormat(0);
                }

                var downpayment = 0;
                var repayments = 0;
                var totalLoan = this.loan * (1 - downpayment) + this.fees;
                var calulation =
                    ((totalLoan * (this.rate / 12)) /
                        (1 - Math.pow(1 + this.rate / 12, -this.months))) *
                    12;

                if (this.frequency == "week") {
                    repayments = calulation / 52;
                } else if (this.frequency == "fortnight") {
                    repayments = calulation / 26;
                } else if (this.frequency == "month") {
                    repayments = calulation / 12;
                }

                return this.currencyFormat(repayments);
            }
        },
        methods: {
            checkForm: function(e) {
                if (this.loan < 2000) {
                    e.preventDefault();
                    document
                        .querySelector(".repayments-calculator-input")
                        .classList.add("invalid");
                    document
                        .querySelector(".invalid-msg")
                        .classList.add("show");
                }
            },
            isNumber: function(evt) {
                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (
                    charCode > 31 &&
                    (charCode < 48 || charCode > 57) &&
                    charCode !== 46
                ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            currencyFormat: function(num) {
                return (
                    "$" +
                    num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                );
            },
            showResults: function(event) {
                // event = (event) ? event : window.event;
                // event.preventDefault();
                // show loading icon
                // event.target.classList.add("loading");
                setTimeout(() => {
                    // wait 1 second and then show results
                    // event.target.classList.remove("loading");
                    document
                        .getElementById("loadingResults")
                        .classList.add("hide");
                    document
                        .getElementById("calcResults")
                        .classList.remove("hide");
                }, 500);
            }
        },
        mounted: function() {
            this.showResults();
            const form = document.getElementById("applicationHomepage");
            const honeypotInput = document.querySelector(
                "[id^=freeform_form_handle_"
            );
            honeypotInput.setAttribute("value", form.dataset.honeypotValue);

        }
    });
}



// WEBPACK FOOTER //
// ./public/js/calculator.js